export function isValidUrl(url: string): boolean {
  try {
    new URL(url)

    return true
  } catch {
    return false
  }
}

export function addProtocol(url: string): string {
  return url.startsWith('http') ? url : `https://${url}`
}

export function isValidFacebookUrl(url: string): boolean {
  if (!url || url.trim() === '') return true

  const fullUrl = addProtocol(url)

  if (!isValidUrl(fullUrl)) return false

  return fullUrl.includes('facebook.com') || fullUrl.includes('fb.com')
}
